import React from 'react';
import Order, { IOrder } from './Order';

import './OrderList.css';

const OrderList: React.FC<{orders: IOrder[]}> = ({ orders }) => {
  return (
    <div className="orders__container">
      <div className="orders__scroll">
        <div className="orders__list">
          {orders.map((order) => (
            <Order key={order.id} order={order} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default OrderList
